export default __webpack_public_path__ + "static/media/contact_bg.a620168b.jpg";